// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YEM7","textarea":"styles_textarea__dgs35"};